var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "management-page-outer-container" }, [
    _c(
      "div",
      {
        staticClass: "data-bigger-side-container scroll-fire-fox",
        staticStyle: { padding: "90px 40px" }
      },
      [
        _c(
          "div",
          { staticClass: "management-section-wrapper" },
          [
            _c(
              "v-card-title",
              [
                _c("span", { staticClass: "management-section-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$tc("AssetReservation", 2)) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticClass: "mr-3", attrs: { xs2: "" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: _vm.$tc("Workspace", 1),
                        value: _vm.workspaceUuid,
                        items: _vm.workspaceOptions,
                        loading: _vm.workspaceOptionsAreLoading,
                        "item-text": "wp_label",
                        "item-value": "wp_uuid",
                        clearable: ""
                      },
                      on: {
                        change: function($event) {
                          return _vm.$emit("update-workspace-uuid", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { staticClass: "mr-3", attrs: { xs2: "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("Search"),
                        placeholder: _vm.$t("Search"),
                        value: _vm.search,
                        "append-icon": "search",
                        "single-line": ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.$emit("update-search", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("reservations-table", {
              attrs: {
                reservations: _vm.reservations,
                loading: _vm.loading,
                "workspace-uuid": _vm.workspaceUuid,
                "is-normal-user": _vm.isNormalUser,
                "search-from-parent": _vm.search
              },
              on: { "open-reservation": _vm.openReservation }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "data-smaller-side-container" },
      [
        _c("side-map", {
          attrs: {
            "workspace-uuid": _vm.workspaceUuid,
            reservations: _vm.reservations
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54a4df2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54a4df2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/ReservationsList.vue
// module id = null
// module chunks = 